import { setForgetPasswordStep, setOTP } from '../../../../store/forgetPassword/slice';
import { resetPasswordThunk } from '../../../../store/forgetPassword/thunks';
import { useDispatch, useSelector } from '../../../../store/store';
import { useCountDown } from '../../../../hooks/useCountDown';
import { TypographyLogo } from '../../../../assets/icons';
import { toTime } from '../../../../utils/generalHelpers';
import styles from './style.module.scss';
import Button from '../../../../components/Button';
import OTP from '../../../../components/OTP';
import { useEffect, useState } from 'react';
import {
    selectUsername,
    selectFetchStatus,
} from '../../../../store/forgetPassword/selectors';

function Verify() {
    const [otp, setOtp] = useState('');
    const username = useSelector(selectUsername);
    const { counter, restart } = useCountDown(180, 'start');
    const { minutes, seconds } = toTime(counter);
    const dispatch = useDispatch();

    useEffect(() => {
        if (otp.length === 6) next();
    }, [otp]);

    const next = () => {
        if (otp.length < 6) return;
        dispatch(setOTP(otp));
        dispatch(setForgetPasswordStep('ResetPassword'))
    };

    const resendOTPCode = () => {
        if (!username || counter > 0) return;
        restart();
        dispatch(resetPasswordThunk(username));
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.head}>
                <TypographyLogo width={280} height={70} />
                <span className={styles.head_devider} />
                <span className={styles.head_title}>Forgot password</span>
            </div>
            <span className={styles.description}>
                Verify your Account, enter the Sent Code to:
            </span>
            <div className={styles.detail}>
                <div className={styles.detail_email}>
                    <span>{username}</span>
                </div>
                <span
                    className={styles.detail_change_mail}
                    onClick={() => dispatch(setForgetPasswordStep('Username'))}
                >
                    Change e-mail
                </span>
            </div>
            <OTP
                value={otp}
                onChange={setOtp}
                numInputs={6}
                onChangeRegex={/^([0-9]{0,})$/}
            />
            <div className={styles.counter}>
                {counter > 0 ? <span className={styles.counter_time}>
                    {minutes}:{seconds} minutes to new one time password
                </span> :
                    <span
                        data-is-deactive={counter > 0}
                        onClick={resendOTPCode}
                        className={styles.counter_resend}
                    >
                        Resend code
                    </span>}
            </div>
            <Button
                text="Confirm"
                onClick={next}
                className={styles.next}
                disabled={otp.length < 6}
            />
        </div>
    )
}

export default Verify;
